// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Theme-based CSS Custom Properties
 * WCAG 2.1 AA compliant color schemes for light and dark modes
 */

/* Default theme (light mode) */
:root {
  /* Primary colors */
  --color-primary: #1976d2;
  --color-primary-text: #ffffff;

  /* Surface colors */
  --color-surface: #ffffff;
  --color-surface-text: #1c1b1f;

  /* Background colors */
  --color-background: #fef7ff;
  --color-background-text: #1c1b1f;

  /* Accent and interaction colors */
  --color-accent: #6750a4;
  --color-accent-text: #ffffff;
  --color-outline: #79747e;

  /* Semantic colors */
  --color-success: #2e7d32;
  --color-warning: #f57c00;
  --color-error: #d32f2f;

  /* Theme-specific properties */
  --theme-name: 'light';
  --shadow-color: rgba(0, 0, 0, 0.1);
  --border-color: rgba(0, 0, 0, 0.12);
  --hover-overlay: rgba(0, 0, 0, 0.04);
  --focus-overlay: rgba(0, 0, 0, 0.08);

  /* Sidebar colors */
  --sidebar-bg: #f8f9fa;
  --sidebar-text: #333333;
  --sidebar-hover: #e9ecef;
  --sidebar-active: #007bff;
  --sidebar-active-text: #ffffff;

  /* Category colors */
  --category-border: #dee2e6;
  --category-hover-bg: #f0f0f0;
}

/* Dark theme */
[data-theme="dark"] {
  /* Primary colors */
  --color-primary: #d0bcff;
  --color-primary-text: #371e73;

  /* Surface colors */
  --color-surface: #1c1b1f;
  --color-surface-text: #e6e0e9;

  /* Background colors */
  --color-background: #141218;
  --color-background-text: #e6e0e9;

  /* Accent and interaction colors */
  --color-accent: #d0bcff;
  --color-accent-text: #371e73;
  --color-outline: #938f99;

  /* Semantic colors */
  --color-success: #81c784;
  --color-warning: #ffb74d;
  --color-error: #f48fb1;

  /* Theme-specific properties */
  --theme-name: 'dark';
  --shadow-color: rgba(0, 0, 0, 0.3);
  --border-color: rgba(255, 255, 255, 0.12);
  --hover-overlay: rgba(255, 255, 255, 0.04);
  --focus-overlay: rgba(255, 255, 255, 0.08);

  /* Sidebar colors */
  --sidebar-bg: #2b2b2b;
  --sidebar-text: #e0e0e0;
  --sidebar-hover: #3a3a3a;
  --sidebar-active: #4a9eff;
  --sidebar-active-text: #ffffff;

  /* Category colors */
  --category-border: #404040;
  --category-hover-bg: #333333;
}

/* Base styles for themed components */
.themed-surface {
  background-color: var(--color-surface);
  color: var(--color-surface-text);
  border: 1px solid var(--border-color);
}

.themed-background {
  background-color: var(--color-background);
  color: var(--color-background-text);
}

.themed-primary {
  background-color: var(--color-primary);
  color: var(--color-primary-text);
}

.themed-accent {
  background-color: var(--color-accent);
  color: var(--color-accent-text);
}

/* Interactive element states */
.themed-button {
  background-color: var(--color-primary);
  color: var(--color-primary-text);
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.themed-button:hover {
  background-color: var(--color-primary);
  box-shadow: 0 2px 4px var(--shadow-color);
  transform: translateY(-1px);
}

.themed-button:focus {
  outline: 2px solid var(--color-accent);
  outline-offset: 2px;
}

.themed-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

/* Form elements */
.themed-input {
  background-color: var(--color-surface);
  color: var(--color-surface-text);
  border: 1px solid var(--color-outline);
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 14px;
}

.themed-input:focus {
  outline: none;
  border-color: var(--color-primary);
  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.2);
}

[data-theme="dark"] .themed-input:focus {
  box-shadow: 0 0 0 2px rgba(208, 188, 255, 0.2);
}

/* Table styles for admin interface */
.themed-table {
  background-color: var(--color-surface);
  color: var(--color-surface-text);
  border-collapse: collapse;
  width: 100%;
  border-radius: 4px;
  overflow: hidden;
}

.themed-table th {
  background-color: var(--color-primary);
  color: var(--color-primary-text);
  padding: 12px;
  text-align: left;
  font-weight: 600;
}

.themed-table td {
  padding: 12px;
  border-bottom: 1px solid var(--border-color);
}

.themed-table tr:hover {
  background-color: var(--hover-overlay);
}

.themed-table tr:last-child td {
  border-bottom: none;
}

/* Status indicators */
.status-success {
  color: var(--color-success);
}

.status-warning {
  color: var(--color-warning);
}

.status-error {
  color: var(--color-error);
}

/* Theme transition animation */
* {
  transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease;
}

/* Accessibility improvements */
@media (prefers-reduced-motion: reduce) {
  * {
    transition: none !important;
  }
}

/* High contrast mode support */
@media (prefers-contrast: high) {
  :root {
    --color-outline: #000000;
    --border-color: #000000;
  }

  [data-theme="dark"] {
    --color-outline: #ffffff;
    --border-color: #ffffff;
  }
}

/* Print styles */
@media print {
  :root {
    --color-background: #ffffff;
    --color-background-text: #000000;
    --color-surface: #ffffff;
    --color-surface-text: #000000;
    --shadow-color: transparent;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/themes.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF,+BAA+B;AAC/B;EACE,mBAAmB;EACnB,wBAAwB;EACxB,6BAA6B;;EAE7B,mBAAmB;EACnB,wBAAwB;EACxB,6BAA6B;;EAE7B,sBAAsB;EACtB,2BAA2B;EAC3B,gCAAgC;;EAEhC,kCAAkC;EAClC,uBAAuB;EACvB,4BAA4B;EAC5B,wBAAwB;;EAExB,oBAAoB;EACpB,wBAAwB;EACxB,wBAAwB;EACxB,sBAAsB;;EAEtB,8BAA8B;EAC9B,qBAAqB;EACrB,kCAAkC;EAClC,mCAAmC;EACnC,oCAAoC;EACpC,oCAAoC;;EAEpC,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,8BAA8B;;EAE9B,oBAAoB;EACpB,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA,eAAe;AACf;EACE,mBAAmB;EACnB,wBAAwB;EACxB,6BAA6B;;EAE7B,mBAAmB;EACnB,wBAAwB;EACxB,6BAA6B;;EAE7B,sBAAsB;EACtB,2BAA2B;EAC3B,gCAAgC;;EAEhC,kCAAkC;EAClC,uBAAuB;EACvB,4BAA4B;EAC5B,wBAAwB;;EAExB,oBAAoB;EACpB,wBAAwB;EACxB,wBAAwB;EACxB,sBAAsB;;EAEtB,8BAA8B;EAC9B,oBAAoB;EACpB,kCAAkC;EAClC,yCAAyC;EACzC,0CAA0C;EAC1C,0CAA0C;;EAE1C,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,8BAA8B;;EAE9B,oBAAoB;EACpB,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA,sCAAsC;AACtC;EACE,sCAAsC;EACtC,gCAAgC;EAChC,qCAAqC;AACvC;;AAEA;EACE,yCAAyC;EACzC,mCAAmC;AACrC;;AAEA;EACE,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;EACrC,+BAA+B;AACjC;;AAEA,+BAA+B;AAC/B;EACE,sCAAsC;EACtC,gCAAgC;EAChC,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,sCAAsC;EACtC,gCAAgC;EAChC,sCAAsC;EACtC,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,8CAA8C;AAChD;;AAEA,qCAAqC;AACrC;EACE,sCAAsC;EACtC,gCAAgC;EAChC,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,gCAAgC;EAChC,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,+BAA+B;AAC/B;EACE,+EAA+E;AACjF;;AAEA,+BAA+B;AAC/B;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA,+BAA+B;AAC/B;EACE;IACE,wBAAwB;IACxB,uBAAuB;EACzB;;EAEA;IACE,wBAAwB;IACxB,uBAAuB;EACzB;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,2BAA2B;IAC3B,gCAAgC;IAChC,wBAAwB;IACxB,6BAA6B;IAC7B,2BAA2B;EAC7B;AACF","sourcesContent":["/**\n * Theme-based CSS Custom Properties\n * WCAG 2.1 AA compliant color schemes for light and dark modes\n */\n\n/* Default theme (light mode) */\n:root {\n  /* Primary colors */\n  --color-primary: #1976d2;\n  --color-primary-text: #ffffff;\n\n  /* Surface colors */\n  --color-surface: #ffffff;\n  --color-surface-text: #1c1b1f;\n\n  /* Background colors */\n  --color-background: #fef7ff;\n  --color-background-text: #1c1b1f;\n\n  /* Accent and interaction colors */\n  --color-accent: #6750a4;\n  --color-accent-text: #ffffff;\n  --color-outline: #79747e;\n\n  /* Semantic colors */\n  --color-success: #2e7d32;\n  --color-warning: #f57c00;\n  --color-error: #d32f2f;\n\n  /* Theme-specific properties */\n  --theme-name: 'light';\n  --shadow-color: rgba(0, 0, 0, 0.1);\n  --border-color: rgba(0, 0, 0, 0.12);\n  --hover-overlay: rgba(0, 0, 0, 0.04);\n  --focus-overlay: rgba(0, 0, 0, 0.08);\n\n  /* Sidebar colors */\n  --sidebar-bg: #f8f9fa;\n  --sidebar-text: #333333;\n  --sidebar-hover: #e9ecef;\n  --sidebar-active: #007bff;\n  --sidebar-active-text: #ffffff;\n\n  /* Category colors */\n  --category-border: #dee2e6;\n  --category-hover-bg: #f0f0f0;\n}\n\n/* Dark theme */\n[data-theme=\"dark\"] {\n  /* Primary colors */\n  --color-primary: #d0bcff;\n  --color-primary-text: #371e73;\n\n  /* Surface colors */\n  --color-surface: #1c1b1f;\n  --color-surface-text: #e6e0e9;\n\n  /* Background colors */\n  --color-background: #141218;\n  --color-background-text: #e6e0e9;\n\n  /* Accent and interaction colors */\n  --color-accent: #d0bcff;\n  --color-accent-text: #371e73;\n  --color-outline: #938f99;\n\n  /* Semantic colors */\n  --color-success: #81c784;\n  --color-warning: #ffb74d;\n  --color-error: #f48fb1;\n\n  /* Theme-specific properties */\n  --theme-name: 'dark';\n  --shadow-color: rgba(0, 0, 0, 0.3);\n  --border-color: rgba(255, 255, 255, 0.12);\n  --hover-overlay: rgba(255, 255, 255, 0.04);\n  --focus-overlay: rgba(255, 255, 255, 0.08);\n\n  /* Sidebar colors */\n  --sidebar-bg: #2b2b2b;\n  --sidebar-text: #e0e0e0;\n  --sidebar-hover: #3a3a3a;\n  --sidebar-active: #4a9eff;\n  --sidebar-active-text: #ffffff;\n\n  /* Category colors */\n  --category-border: #404040;\n  --category-hover-bg: #333333;\n}\n\n/* Base styles for themed components */\n.themed-surface {\n  background-color: var(--color-surface);\n  color: var(--color-surface-text);\n  border: 1px solid var(--border-color);\n}\n\n.themed-background {\n  background-color: var(--color-background);\n  color: var(--color-background-text);\n}\n\n.themed-primary {\n  background-color: var(--color-primary);\n  color: var(--color-primary-text);\n}\n\n.themed-accent {\n  background-color: var(--color-accent);\n  color: var(--color-accent-text);\n}\n\n/* Interactive element states */\n.themed-button {\n  background-color: var(--color-primary);\n  color: var(--color-primary-text);\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.themed-button:hover {\n  background-color: var(--color-primary);\n  box-shadow: 0 2px 4px var(--shadow-color);\n  transform: translateY(-1px);\n}\n\n.themed-button:focus {\n  outline: 2px solid var(--color-accent);\n  outline-offset: 2px;\n}\n\n.themed-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* Form elements */\n.themed-input {\n  background-color: var(--color-surface);\n  color: var(--color-surface-text);\n  border: 1px solid var(--color-outline);\n  padding: 8px 12px;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.themed-input:focus {\n  outline: none;\n  border-color: var(--color-primary);\n  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.2);\n}\n\n[data-theme=\"dark\"] .themed-input:focus {\n  box-shadow: 0 0 0 2px rgba(208, 188, 255, 0.2);\n}\n\n/* Table styles for admin interface */\n.themed-table {\n  background-color: var(--color-surface);\n  color: var(--color-surface-text);\n  border-collapse: collapse;\n  width: 100%;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.themed-table th {\n  background-color: var(--color-primary);\n  color: var(--color-primary-text);\n  padding: 12px;\n  text-align: left;\n  font-weight: 600;\n}\n\n.themed-table td {\n  padding: 12px;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.themed-table tr:hover {\n  background-color: var(--hover-overlay);\n}\n\n.themed-table tr:last-child td {\n  border-bottom: none;\n}\n\n/* Status indicators */\n.status-success {\n  color: var(--color-success);\n}\n\n.status-warning {\n  color: var(--color-warning);\n}\n\n.status-error {\n  color: var(--color-error);\n}\n\n/* Theme transition animation */\n* {\n  transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease;\n}\n\n/* Accessibility improvements */\n@media (prefers-reduced-motion: reduce) {\n  * {\n    transition: none !important;\n  }\n}\n\n/* High contrast mode support */\n@media (prefers-contrast: high) {\n  :root {\n    --color-outline: #000000;\n    --border-color: #000000;\n  }\n\n  [data-theme=\"dark\"] {\n    --color-outline: #ffffff;\n    --border-color: #ffffff;\n  }\n}\n\n/* Print styles */\n@media print {\n  :root {\n    --color-background: #ffffff;\n    --color-background-text: #000000;\n    --color-surface: #ffffff;\n    --color-surface-text: #000000;\n    --shadow-color: transparent;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
